//Generated File 
export default class PlaceTokens{
	static readonly FIELDS_SELECTOR_POPUP = `fieldsSelectorPopup`;
	static readonly LAYOUT_EDITOR_VIEW = `layouteditor`;
	static readonly PAIR_SEPERATOR = `/`;
	static readonly PARAMETERS_SEPERATOR = `&`;
	static readonly PREFIX_APPROVALS = `approvals`;
	static readonly PREFIX_CONFIGURATION = `configuration`;
	static readonly PREFIX_EDIT = `edit`;
	static readonly PREFIX_EDIT_FILE = `editfile`;
	static readonly PREFIX_EDIT_LAYOUT = `layoutedit`;
	static readonly PREFIX_ENTITY_CONFIG = `entityconfig`;
	static readonly PREFIX_Email = `emails`;
	static readonly PREFIX_LAUNCH_REPORT = `rpt`;
	static readonly PREFIX_LIST = `list`;
	static readonly PREFIX_REPORT_List = `rptlst`;
	static readonly PREFIX_REPORT_Result = `rptres`;
	static readonly PREFIX_WELCOME = ``;
	static readonly PREFIX_login = `login`;
	static readonly PREFIX_notifications = `notifications`;
	static readonly PREFIX_sql = `sql`;
	static readonly PREFIX_userloginhistory = `userloginhistory`;
	static readonly PRM_ASCENDING = `asc`;
	static readonly PRM_CODE = `code`;
	static readonly PRM_CREATED_OBJECT_ID = `createdObjectId`;
	static readonly PRM_CRITERIA = `criteria`;
	static readonly PRM_CROSS_FILTERS = `cf`;
	static readonly PRM_DASHBOARDID = `dsh`;
	static readonly PRM_DATA_SOURCE_1 = `dataSource1`;
	static readonly PRM_DATA_SOURCE_2 = `dataSource2`;
	static readonly PRM_DATA_SOURCE_3 = `dataSource3`;
	static readonly PRM_DATA_SOURCE_4 = `dataSource4`;
	static readonly PRM_DATA_SOURCE_5 = `dataSource5`;
	static readonly PRM_DEBUG = `dbg`;
	static readonly PRM_DOWNLOAD_PURPOSE = `dwnldprp`;
	static readonly PRM_EDIT_TEMPLATE_ID = `tmplt`;
	static readonly PRM_EDIT_VIEW_NAME = `eview`;
	static readonly PRM_ENTITYID = `eid`;
	static readonly PRM_ENTITY_TYPE = `entity`;
	static readonly PRM_EXTRA_CRITERIA = `extrcrt`;
	static readonly PRM_EXTRA_FIELD_FILTER = `extrfltr`;
	static readonly PRM_FIELDS = `fields`;
	static readonly PRM_FIELD_TITLE = `fieldTitle`;
	static readonly PRM_FLOW_ID = `flowid`;
	static readonly PRM_FLOW_TARGET_ID = `flowttargetid`;
	static readonly PRM_FLOW_TARGET_TYPE = `flowtargettype`;
	static readonly PRM_FOCUS_ON_FIELD = `focusOnField`;
	static readonly PRM_FORM_REPORT_ID = `formReportId`;
	static readonly PRM_FOR_MOBILE_VIEW = `forMobileView`;
	static readonly PRM_FOR_QUICK_CREATOR_VIEW = `forQuickCreatorView`;
	static readonly PRM_ID = `id`;
	static readonly PRM_IMPORT_OBJECTS = `importObjects`;
	static readonly PRM_IS_FORM = `isForm`;
	static readonly PRM_IS_FROM_REPORTING_ENTITY = `isFromReportingEntity`;
	static readonly PRM_LANGUAGE = `lang`;
	static readonly PRM_LIST_VIEW_NAME = `lview`;
	static readonly PRM_LOGOUT = `logout`;
	static readonly PRM_MENU_HASH = `menu`;
	static readonly PRM_MONIOR_ID = `mntr`;
	static readonly PRM_NESTING = `nesting`;
	static readonly PRM_OUTPUT_FORMAT = `frmt`;
	static readonly PRM_OWNER_ID = `ownerid`;
	static readonly PRM_OWNER_TYPE = `ownertype`;
	static readonly PRM_PAGE = `page`;
	static readonly PRM_PAGE_ID = `pgid`;
	static readonly PRM_PAGE_SIZE = `pageSize`;
	static readonly PRM_PENDING_RESPONSE_ID = `pendingResponseId`;
	static readonly PRM_PRINTER_NAME = `prntrname`;
	static readonly PRM_PRINTING_OPTION = `prntopt`;
	static readonly PRM_QUESTIONS = `questions`;
	static readonly PRM_QUICKCREATE = `quick`;
	static readonly PRM_QUICKCREATE_REQUESTER = `quickreq`;
	static readonly PRM_REDIRECT = `redirect`;
	static readonly PRM_REPLICATION_OPTIONS = `repl`;
	static readonly PRM_REPORT_WIZARD_ID = `reportWizardId`;
	static readonly PRM_RESET_TOKEN = `rsttkn`;
	static readonly PRM_RESET_USER = `rstusr`;
	static readonly PRM_ROOT = `root`;
	static readonly PRM_ROOT_TYPE = `rootType`;
	static readonly PRM_SCREEN_TYPE = `screenType`;
	static readonly PRM_SERVEROBJECT = `srvrobj`;
	static readonly PRM_SHOW_IDS = `showids`;
	static readonly PRM_SHOW_TREE = `tree`;
	static readonly PRM_SORT_BY = `sort`;
	static readonly PRM_SUB_DASHBOARD = `sd`;
	static readonly PRM_TAB_ID = `tabid`;
	static readonly PRM_TEMP_PRINT_ID = `tmpprnt`;
	static readonly PRM_VERSION = `version`;
	static readonly PRM_VIEW = `view`;
	static readonly REPORT_EXPRESSION_EDITOR = `reportExpressionEditor`;
	static readonly REPORT_UNION_HANDLING_EDITOR = `reportUnionHandlingEditor`;
	static readonly REPORT_WIZARD_EDITOR = `reportWizardEditor`;
	static readonly WIZARD_VIEW = `wizard`;
}
